import { motion } from "framer-motion";
import { BookOpen, Blocks, HeartHandshake, CalendarClock } from "lucide-react";
import { images } from "@/data/content";

const pillars = [
  { icon: BookOpen, color: "#45B7D1", title: "Base na BNCC", text: "A partir dos 2 anos, material didático atualizado e alinhado às diretrizes da BNCC." },
  { icon: Blocks, color: "#FF9F1C", title: "Aprender brincando", text: "Brincadeiras e atividades lúdicas como ferramentas centrais de aprendizagem." },
  { icon: CalendarClock, color: "#4ECDC4", title: "Rotina estruturada", text: "Uma rotina organizada que oferece segurança, autonomia e previsibilidade." },
  { icon: HeartHandshake, color: "#FF9ECE", title: "Desenvolvimento integral", text: "Cuidamos dos aspectos cognitivos, sociais, emocionais e motores de cada criança." },
];

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Methodology() {
  return (
    <section id="metodologia" className="relative py-24 md:py-32 bg-surface-alt">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }}>
            <span className="inline-block rounded-full bg-brand-orange/15 text-brand-orange px-4 py-1.5 font-700 text-sm mb-4">
              Proposta pedagógica
            </span>
            <h2 className="font-display font-700 text-ink text-4xl md:text-5xl leading-tight mb-6">
              Equilíbrio entre aprendizagem e ludicidade.
            </h2>
            <p className="font-body text-ink-soft text-lg leading-relaxed mb-8">
              Proporcionamos uma educação acolhedora, significativa e adequada a cada fase do
              desenvolvimento. Aqui a criança aprende, brinca, convive e se desenvolve de forma integral.
            </p>
            <div className="relative rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgb(30,58,95,0.12)]">
              <img src={images.art} alt="Atividades pedagógicas" className="w-full h-72 object-cover" />
            </div>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-5">
            {pillars.map((p, i) => (
              <motion.div
                key={p.title}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-40px" }}
                className={`rounded-3xl bg-white p-7 shadow-[0_8px_30px_rgb(30,58,95,0.05)] hover:-translate-y-1.5 transition-transform duration-300 ${i % 2 === 1 ? "sm:translate-y-6" : ""}`}
                data-testid={`pillar-${i}`}
              >
                <span
                  className="inline-flex h-14 w-14 items-center justify-center rounded-2xl mb-5"
                  style={{ backgroundColor: `${p.color}22` }}
                >
                  <p.icon className="h-7 w-7" strokeWidth={2.5} style={{ color: p.color }} />
                </span>
                <h3 className="font-display font-600 text-ink text-xl mb-2">{p.title}</h3>
                <p className="font-body text-ink-soft leading-relaxed text-[15px]">{p.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
